import { Pipe, PipeTransform, inject } from '@angular/core';
import { CalendarDate } from '@agilox/ui-common';
import { DatepickerTranslationService } from '@agilox/common';

@Pipe({
	name: 'calendarDateTooltip',
	standalone: false,
})
export class CalendarDateTooltipPipe implements PipeTransform {
	private translationService = inject(DatepickerTranslationService);

	transform(value: CalendarDate): string {
		if (!value) {
			return '';
		}
		if (value.disabled) {
			return this.translationService.translate('datepicker.disabled');
		}
		if (value.excluded) {
			return this.translationService.translate('datepicker.excluded');
		}
		return '';
	}
}
